import React from 'react';
import { Box, Typography } from '@mui/material';
import { Icon, Popup } from '@elements';
import { StyledContent, StyledHeader, StyledPopup } from './info.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InfoPopup = function InfoPopup(_ref) {
  var popUp = _ref.popUp;
  var header = popUp && popUp.data && popUp.data.header;
  var body = popUp && popUp.data && popUp.data.body;
  var icon = popUp && popUp.data && popUp.data.icon;
  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 324,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Icon, {
          src: icon,
          width: 40,
          height: 40
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        children: [header && /*#__PURE__*/_jsx(Box, {
          mt: 1.5,
          children: /*#__PURE__*/_jsx(Typography, {
            color: "tuna",
            variant: "h5",
            textAlign: "center",
            fontWeight: 500,
            children: header
          })
        }), body && /*#__PURE__*/_jsx(Box, {
          mt: 1.5,
          children: /*#__PURE__*/_jsx(Typography, {
            color: "tuna",
            variant: "body2",
            textAlign: "center",
            fontWeight: 400,
            children: body
          })
        })]
      })
    })]
  });
};

export { InfoPopup };